import Papa from 'papaparse';

/**
 * Construit le texte CSV (séparateur ";" pour Excel FR). Les tableaux sont joints
 * par ", ", null/undefined deviennent des cellules vides.
 *
 * @param {{ key: string, label: string, value?: (row: any) => any }[]} columns
 * @param {any[]} rows
 * @returns {string}
 */
export const buildCsv = (columns, rows) => {
  const data = rows.map(row => columns.map(col => {
    const v = col.value ? col.value(row) : row[col.key];
    if (v === null || v === undefined) return '';
    return Array.isArray(v) ? v.join(', ') : v;
  }));
  return Papa.unparse({ fields: columns.map(c => c.label), data }, { delimiter: ';' });
};

/**
 * Télécharge un CSV lisible directement par Excel FR : séparateur ";" et BOM UTF-8
 * (sans BOM, Excel décode en Windows-1252 et casse les accents).
 *
 * @param {string} filename - Nom du fichier, ".csv" ajouté si absent
 * @param {{ key: string, label: string, value?: (row: any) => any }[]} columns
 * @param {any[]} rows
 */
export const downloadCsv = (filename, columns, rows) => {
  const blob = new Blob(['﻿', buildCsv(columns, rows)], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

/** Suffixe de date pour les noms de fichiers exportés (AAAA-MM-JJ). */
export const csvDateStamp = () => new Date().toISOString().slice(0, 10);

export default downloadCsv;
